import React, { useEffect, useState, useRef, useMemo, useCallback }from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

import T, { Translate } from '../../i18n/i18n';
import { MessagesList, Title, ButtonBack, ButtonIcon, HeaderRow, MessagesFriendsList, MessageFriendsTitle, MessageListMessages, MessageFriendItem, MessageFriendLetter, MessageFriendName, MessageFriendUnread, NoMessage, FriendHeader, Conversation, SendMessageRow, SendMessageInput, SendMessageButton, MessageLine, MessageMine, MessageOther, MessageTime, MsgJoin, MsgJoinTableImage, MsgJoinTableName, Row, Button, MsgJoinText, Message } from './Messages.styles';
import { getMessagesFriendList, getMessagesFromFriend, saveMessage, acceptJoinFromMessage } from '../../../services/messages';
import { rtcBufferActions, messagesActions } from '../../../redux/actions';
import { ConvertToTimeClock } from '../../../services/dates';
import ResourceImage from '../../ResourceImage/ResourceImage';

const sortFriends = (messagesUnread) => {
    return (a,b) => {
        if (!messagesUnread[a.email] || !messagesUnread[b.email]){
            return 0;
        }
        return messagesUnread[b.email].lastSeen - messagesUnread[a.email].lastSeen
    }
}

export default () => {

    const [selectedFriend, setSelectedFriend] = useState(null);
    const [selectedName, setSelectedName] = useState("");
    const [selectedEmail, setSelectedEmail] = useState("");
    const [messages, setMessages] = useState([]);
    const [messageToSend, setMessageToSend] = useState([]);

    const inputElement = useRef(null);
    const isEnd = useRef(true);
    const chatScrollRef = useRef(null);

    const id = useSelector(state => state.authState.id);
    const email = useSelector(state => state.authState.email);
    const name = useSelector(state => state.authState.name);
    const messagesItems = useSelector(state => state.messagesState.messages);
    const messagesUnread = useSelector(state => state.messagesState.unread);

    const history = useHistory();
    const dispatch = useDispatch();


    let onScroll = () => {
        const scrollTop = chatScrollRef.current.scrollTop;
        const scrollHeight = chatScrollRef.current.scrollHeight;
        const offsetHeight = chatScrollRef.current.offsetHeight;

        isEnd.current = Math.ceil(scrollTop) >= (scrollHeight - offsetHeight - 50);
    };

    const handleBack = () => {
        history.goBack();
    };

    const handleSelected = (friend) => {
        setSelectedName(friend.name);
        setSelectedFriend(friend.id);
        setSelectedEmail(friend.email);
    }

    const handleRefresh = () => {
        let setState = true;

        (async () => {
            let msgs = await getMessagesFriendList();

            if (setState && msgs.status === 'ok') {
                setMessages(msgs.payload);
                setSelectedFriend(null);

                let friends = {};
                for(let i of msgs.payload) {
                    friends[i.email] = {
                        name: i.name,
                        email: i.email,
                        unread: i.unread,
                        lastSeen: i.lastMessage,
                    };
                }

                dispatch(messagesActions.loadFriends(friends));
            }
        })();

        return () => {
            setState = false;
            setSelectedFriend(null);
            setSelectedEmail("");
            setSelectedName("");
        }
    };

    const sendMessage = () => {
        dispatch(rtcBufferActions.pushOutputBuffer({
            type: 'profileMessageSent',
            to: selectedEmail,
            data: JSON.stringify({from: email, to: selectedEmail, message: messageToSend, name})
        }));
        dispatch(messagesActions.sendMessage(email, selectedEmail, messageToSend, selectedName, selectedEmail));

        saveMessage(id, selectedFriend, messageToSend);
        setMessageToSend("");
        inputElement.current.focus();
    }

    const handleMeesageToSend = (e) => {
        setMessageToSend(e.target.value);
    }

    const handleKeyPress = (e) => {
        if (e.which === 13) {
            sendMessage();
        }
    }

    const getFriendMessages = (friendId) => {
        let setState = true;

        (async () => {
            let msgs = await getMessagesFromFriend(friendId);

            if (setState && msgs.status === 'ok') {
                dispatch(messagesActions.loadMessages(selectedEmail, msgs.payload));
            }
        })();

        return () => {setState = false;}
    };

    const handleAcceptJoin = useCallback(async (id, msg) => {
        await acceptJoinFromMessage(id);

        msg.joined = true;

        dispatch(messagesActions.updateMessage(id, JSON.stringify(msg)));

    }, [messagesItems, selectedEmail]);

    const RenderSpecialMessages = useCallback((id, msg, isOwner) => {
        try {
            let message = JSON.parse(msg);
            if (!message.type) {
                return msg;
            }

            if (message.type === 'table-join') {
                return <MsgJoin>
                    <MsgJoinText><T value="messages.joinText" /></MsgJoinText>
                    <Row align="center">
                        <MsgJoinTableImage>
                            { message.image ? <ResourceImage resourceId={message.image} /> : null }
                        </MsgJoinTableImage>
                        <MsgJoinTableName>{message.name}</MsgJoinTableName>
                        {isOwner && message.joined !== true ? <Button color="#f92" onClick={()=>{handleAcceptJoin(id, message)}}><T value="messages.acceptJoin" /></Button> : null}
                    </Row>
                </MsgJoin>
            }
        } catch (e) {
            return msg;
        }
    }, [handleAcceptJoin]);

    const messagesMemo = useMemo(() => {
        return selectedEmail && messagesItems[selectedEmail] ? messagesItems[selectedEmail].map((m,i) => <MessageLine className={m.from===email ? 'right' : 'left'} key={i}>
            {m.from===email ? 
                <MessageMine>
                    {RenderSpecialMessages(m.id, m.message, false)}
                    <MessageTime>{ConvertToTimeClock(m.date)}</MessageTime>
                </MessageMine>
            :
                <MessageOther>
                    {RenderSpecialMessages(m.id, m.message, true)}
                    <MessageTime>{ConvertToTimeClock(m.date)}</MessageTime>
                </MessageOther>
            }
        </MessageLine>) : null;
    }, [messagesItems, selectedEmail, email]);

    const friendsMemo = useMemo(()=> {
        return messages && messages.length ? messages.sort(sortFriends(messagesUnread)).map(m => <MessageFriendItem key={m.id} className={selectedFriend === m.id ? 'selected' : ''} onClick={()=>{handleSelected(m)}}>
            <MessageFriendLetter color={m.color} fgColor={m.fgColor}>{m.name.substring(0,1)}</MessageFriendLetter>
            <MessageFriendName className={!messagesUnread[m.email] ? 'off' : ''}>{m.name}</MessageFriendName>
                { messagesUnread[m.email] && messagesUnread[m.email].unread ? 
                    <MessageFriendUnread>{messagesUnread[m.email].unread}</MessageFriendUnread>
                : null }
            </MessageFriendItem>) : <NoMessage className="noFriends">
                <T value="messages.noMessageFriends" />
            </NoMessage>;
    }, [messages, selectedFriend, handleSelected, messagesUnread]);

    useEffect(()=>{
        let fn = handleRefresh();
        return ()=>{fn()};
    }, []);

    useEffect(() => {
        if (!chatScrollRef.current) {
            return;
        }

        chatScrollRef.current.addEventListener('scroll', onScroll);

        let scrollRef = chatScrollRef.current;
        return () => {
            scrollRef.removeEventListener('scroll', onScroll);
        }
    }, [chatScrollRef.current]);

    useEffect(() => {
        if (!chatScrollRef.current) {
            return;
        }

        if (isEnd.current && messagesItems) {
            chatScrollRef.current.scrollTop = chatScrollRef.current.scrollHeight;
        }
    }, [chatScrollRef, messagesItems, selectedEmail]);

    useEffect(()=>{
        if (selectedFriend) {
            let fn = getFriendMessages(selectedFriend);
            return ()=>{fn()};
        }
    }, [selectedFriend]);
    
    return <>
        <HeaderRow>
            <ButtonBack color="#aaa" onClick={handleBack} />
            <Title><T value="messages.title" /></Title>
            <ButtonIcon color="#f92" onClick={handleRefresh} icon="\F0450" title={Translate("messages.refresh")} />
        </HeaderRow>
        <MessagesList className='scrollbar'>
            <MessagesFriendsList>
                <MessageFriendsTitle><T value="messages.conversations" /></MessageFriendsTitle>
                {friendsMemo}
            </MessagesFriendsList>
            <MessageListMessages>
                {!selectedFriend ? <>
                    <NoMessage>
                        <T value="messages.noMessages" />
                    </NoMessage>
                </> : <>
                    {messagesItems && messagesItems[selectedEmail] && messagesItems[selectedEmail].length > 0 ? <>
                        <FriendHeader><T value="messages.conversationWith" /> {selectedName}</FriendHeader>
                        <Conversation className="scrollbar" ref={chatScrollRef}>
                            {messagesMemo}
                        </Conversation>
                    </> 
                    : 
                        <NoMessage className="noMessage">
                            <T value="messages.noMessages" />
                        </NoMessage>
                    }
                </>}
            </MessageListMessages>

            {selectedFriend ? 
                <SendMessageRow>
                    <SendMessageInput ref={inputElement} placeholder={Translate("messages.sendPlaceholder")} onChange={handleMeesageToSend} value={messageToSend} onKeyPress={handleKeyPress}/>
                    <SendMessageButton title={Translate("send")} />
                </SendMessageRow>
            : null }
        </MessagesList>
    </>
};